import React from "react";
import {Site} from './components';

const routes = {
    "/": () => <Site />
  };
  export default routes;